module.exports = __webpack_public_path__ + "public/img/ele-stop.da870480.png";